import { z } from "zod";

const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Matches YYYY-MM-DD

export const ValidationSchemas = {
  string: z.string().catch(""),
  requiredString: z.string().min(1),
  number: z.number().catch(null),
  email: z.string().email().or(z.literal("")).optional(),
  requiredEmail: z.string().email(),
  boolean: z.boolean().catch(false),
  requiredBoolean: z.boolean(),
  requiredTrueBoolean: z.literal(true),
  requiredFalseBoolean: z.literal(false),
  positiveInt: z.number().int().nonnegative(),
  coordinate: {
    lat: z
      .number()
      .min(-90, "Latitude must be between -90 and 90")
      .max(90, "Latitude must be between -90 and 90"),
    lon: z
      .number()
      .min(-180, "Longitude must be between -180 and 180")
      .max(180, "Longitude must be between -180 and 180"),
  },
  date: z.string().regex(dateRegex, "Must be YYYY-MM-DD").catch(null),
  requiredDate: z.preprocess(
    (val) => {
      const d = new Date(val);
      return isNaN(d.getTime()) ? undefined : d;
    },
    z.date({
      required_error: "Date is required",
      invalid_type_error: "Must be YYYY-MM-DD",
    })
  ),
  datetime: z.string().datetime().catch(null),
  readOnlyNullableString: z.string().nullable().default(null),
  readOnlyNullableNumber: z.number().nullable().default(null),
};

export const lookupConfig = {
  drillersList: {
    tableName: "drillers_list",
    idField: "contact_ndx",
    labelField: "name",
  },
  installersList: {
    tableName: "installers_list",
    idField: "contact_ndx",
    labelField: "name",
  },
  groundwaterManagementZones: {
    tableName: "list_drought_zone",
    idField: "zone_ndx",
    labelField: "zone_desc",
  },
  paymentMethods: {
    tableName: "list_payment_method",
    idField: "payment_meth_ndx",
    labelField: "payment_meth_desc",
  },
  pwsOperators: {
    tableName: "list_pws_operators",
    idField: "access_contact_ndx",
    labelField: "contact",
  },
};

export const formDefaults = {
  number: null,
  text: "",
  checkbox: false,
  radioBoolean: null,
  selectSingle: null,
  selectMulti: [],
  date: null,
  dateTime: null,
};
